<template>
  <div @keyup.13="submit">
    <mu-dialog
      title="新增投资"
      width="500"
      :open="open"
      @close="close"
      class="create-dialog"
    >
      <mu-form :model="form" label-position="left" label-width="100" ref="form">
        <mu-form-item prop="user" label="姓名">
          <mu-select v-model="form.user.id">
            <mu-option
              v-for="(item, index) in allUserList"
              :key="index"
              :label="item.realName"
              :value="item.id"
            ></mu-option>
          </mu-select>
        </mu-form-item>

        <mu-form-item prop="money" label="金额">
          <mu-text-field v-model="form.money"></mu-text-field>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        user: {
          id: 1
        },
        money: ''
      },
      allUserList: []
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate().then((flag) => {
        if (flag) {
          backend(api.contribute.create, this.form).then((result) => {
            if (result.statusCode === 200) {
              this.close()
              this.$emit('finish')
              this.form = {
                user: {
                  id: 1
                },
                money: ''
              }
            }
          })
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    },
    getAllUser() {
      backend(api.user.getAll, { getAll: true, isClerk: true }).then((res) => {
        if (res.statusCode === 200) {
          this.allUserList = res.data.rows
        }
      })
    }
  },
  mounted() {
    this.getAllUser()
  }
}
</script>

<style lang="less" scoped>
.create-dialog {
}
</style>



// WEBPACK FOOTER //
// src/views/contribute/create.vue